import ProfileDropdown from "./ProfileDropdown";
import { OptimizedSvg } from "@components/common/OptimizedSvg";
import { userProfile } from "@tvet-mis/psda-assets";
import { useProfile } from "./services/GetProfile";
import isEmpty from "@utils/isEmpty";
import { useAttachmentByFilename } from "@hooks/useAttachmentByFilename";
import { CircularProgress } from "@mui/material";

const Profile = () => {
	const { data } = useProfile();
	const profilePicture = data?.profilePicture;
	const personFullName = data?.businessDetails?.person?.fullName;
	const businessName = data?.businessDetails?.businessName;

	const { url: profilePictureUrl, loading: isLoadingProfilePicture } = useAttachmentByFilename(profilePicture, {
		enabled: !!profilePicture,
	});

	const fullName = personFullName || businessName || "";
	const hasName = !isEmpty(fullName);

	const avatar = profilePictureUrl ? (
		<img src={profilePictureUrl} alt="Profile" />
	) : isLoadingProfilePicture && profilePicture ? (
		<CircularProgress size={24} />
	) : (
		<OptimizedSvg
			src={userProfile}
			alt="user profile"
			className="header-profile-avatar__svg"
			cacheKey="user-profile"
		/>
	);

	return (
		<div className="header-profile-pill" aria-label={hasName ? fullName : "Profile menu"}>
			<div className="header-profile-avatar">{avatar}</div>
			<div className="header-profile-chevron">
				<ProfileDropdown />
			</div>
		</div>
	);
};

export default Profile;
